import React from 'react';
import { Outlet } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Container, Grid } from '@mui/material';
import BlogContent from './components/BlogContent';
import RecentPosts from './components/RecentPosts';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
}));

const BlogDetails = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        {/* Main Content Column */}
        <Grid item xs={12} md={10}>
          <BlogContent />
        </Grid>

        {/* Sidebar Column */}
        <Grid item xs={12} md={2}>
          <RecentPosts />
        </Grid>
      </Grid>
    </Container>
  );
};

export default BlogDetails;
